export default function Meta({ title }: { title: string }) {
  return <title>{`${title} | Leaguestar`}</title>
}
